import { getCurrentTime } from '../../helpers';

const CurrentWeather = ({ icon, temp, outlook }) => {
	const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	let getDate = new Date();
	let currentDay = days[getDate.getDay()];

	return (
		<div className='current-weather'>
			<img className='current-weather__image' src={`../icons/${icon}.svg`} alt={`${icon} weather icon`} />
			<div className='current-weather__temperature'>
				<h3>
					{temp}
					<sup>°C</sup>
				</h3>
				<p>
					<strong>{currentDay},</strong> <span>{getCurrentTime()}</span>
				</p>
				<p>{outlook}</p>
			</div>
		</div>
	);
};

export default CurrentWeather;
